import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { LoginAPI } from "../api/loginAPI";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import {  ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Visibility } from "@mui/icons-material";
import { VisibilityOff } from "@mui/icons-material";
export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (values) => {
    const response = await LoginAPI(values);
    if (response.status === 200) {
      navigate("/");
    }
  };

  return (
    <>
      <ToastContainer />
      <div class="main-outer">
        <div class="container">
          <div class="row justify-content-center ">
            <div class="col-md-6">
              <div className=" mb-5">
                <img
                  src={logo}
                  alt="Logo"
                  style={{ maxWidth: "281px", maxHeight: "233px" }}
                />
              </div>
              <div class="text-center outer-card outer-card">
                <p class="heading-form mb-4 fs-3">Login Here</p>
                <form class="inner-card" onSubmit={handleSubmit(onSubmit)}>
                  <div class="form-group">
                    <label for="email">Email</label>
                    <input
                      type="text"
                      class="form-control"
                      id="email"
                      placeholder="example@gmail.com"
                      {...register("email", { required: true })}
                    />
                    {errors.email && (
                      <p class="text-danger">Email is required.</p>
                    )}
                  </div>
                  <div class="form-group" style={{ position: "relative" }}>
                    <label for="password">Password</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      class="form-control "
                      id="password"
                      placeholder="password"
                      {...register("password", { required: true })}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "17px",
                        top: "67%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </span>
                    {errors.password && (
                      <p class="text-danger">Password is required.</p>
                    )}
                  </div>
                  <div class="form-group mt-4 text-center">
                    <button type="submit" class="btn btn-warning btn-block">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
